import React from 'react';
import { makeStyles, Typography, Tooltip } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import Picture from './Picture';
import { isInteger } from 'lodash';
import PropTypes from 'prop-types';

import {
  // Battery Icons
  BatteryUnknown as BatteryUnknownIcon,
  Battery20 as Battery20Icon,
  Battery30 as Battery30Icon,
  Battery50 as Battery50Icon,
  Battery60 as Battery60Icon,
  Battery80 as Battery80Icon,
  Battery90 as Battery90Icon,
  BatteryFull as BatteryFullIcon,
  // Signal Icons
  SignalCellularNullRounded as SignalCellularNullIcon,
  SignalCellular0BarRounded as SignalCellular0BarIcon,
  SignalCellular1BarRounded as SignalCellular1BarIcon,
  SignalCellular2BarRounded as SignalCellular2BarIcon,
  SignalCellular3BarRounded as SignalCellular3BarIcon,
  SignalCellular4BarRounded as SignalCellular4BarIcon,
  // Other Icons
  FiberManualRecord as DotIcon
} from '@material-ui/icons';

import { green, grey, red, deepOrange, lightGreen } from '@material-ui/core/colors';




const useStyles = makeStyles(theme => ({
  root: {
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.9
    }
  },
  content: {
    display: 'flex',
    justifyContent: 'space-between',
    position: 'relative',
    paddingTop: theme.spacing(1)
  },
  statusContainer: {
    display: 'flex',
    alignItems: 'middle'
  },
  statusItem: {
    float: 'right',
    display: 'flex',
    alignItems: 'center'
  }
}));




function parseBattery(percent) {
  var BatteryIcon = BatteryUnknownIcon;
  var batteryColor = grey[500];
  var battery = null;

  if (percent) {
    battery = percent;
    if (battery < 25) {
      BatteryIcon = Battery20Icon;
      batteryColor = red[500];
    } else if (battery < 40) {
      BatteryIcon = Battery30Icon;
      batteryColor = deepOrange[700];
    } else if (battery < 55) {
      BatteryIcon = Battery50Icon;
      batteryColor = deepOrange[400];
    } else if (battery < 75) {
      BatteryIcon = Battery60Icon;
      batteryColor = lightGreen[500];
    } else if (battery < 85) {
      BatteryIcon = Battery80Icon;
      batteryColor = lightGreen[500];
    } else if (battery < 95) {
      BatteryIcon = Battery90Icon;
      batteryColor = green[500];
    } else if (battery <= 100) {
      BatteryIcon = BatteryFullIcon;
      batteryColor = green[500];
    }
  }

  return { BatteryIcon, batteryColor, battery };
}

function parseSignal(strength) {
  var SignalIcon = SignalCellularNullIcon;;
  var signalColor = grey[500];
  var signal = null;

  if (strength === 0) {
    SignalIcon = SignalCellular0BarIcon;
    signalColor = red[500];
    signal = 0;
  } else if (strength === 1) {
    SignalIcon = SignalCellular1BarIcon;
    signalColor = deepOrange[500];
    signal = 25;
  } else if (strength === 2) {
    SignalIcon = SignalCellular2BarIcon;
    signalColor = lightGreen[500];
    signal = 50;
  } else if (strength === 3) {
    SignalIcon = SignalCellular3BarIcon;
    signalColor = green[500];
    signal = 75;
  } else if (strength >= 4) {
    SignalIcon = SignalCellular4BarIcon;
    signalColor = green[500];
    signal = 100;
  }

  return { SignalIcon, signalColor, signal };
}

function parseAlarm(status) {
  var AlarmIcon = DotIcon;
  var alarmColor = green[500];
  var alarm = false;

  if (status === true) {
    alarmColor = red[500];
    alarm = true;
  }

  return { AlarmIcon, alarmColor, alarm };
}




function SiteCard(props) {
  const { business, site } = props;
  const { device } = site;
  const classes = useStyles();
  const history = useHistory();

  const { BatteryIcon, batteryColor, battery } = parseBattery(device.battery);
  const { SignalIcon, signalColor, signal } = parseSignal(device.signal);
  const { AlarmIcon, alarmColor, alarm } = parseAlarm(device.alarm);

  return (
    <div
      className={classes.root}
      onClick={() => history.push(
        `/business/${business.url || business.id}/site/${site.url || site.id}`
      )}
    >
      <Picture image={site.latestImage} />

      <div className={classes.content}>
        <div>
          <Typography variant='h6'>
            {site.name}
          </Typography>
          <Typography variant='h6' style={{ fontWeight: 300 }}>
            {site.siteGroup.city}
          </Typography>
        </div>

        <div className={classes.statusContainer}>
          <div className={classes.statusItem} style={{ color: batteryColor }}>
            <Tooltip title={`Battery: ${isInteger(battery) ? `${battery}%` : 'Unknown'}`}>
              <BatteryIcon color='inherit' />
            </Tooltip>
          </div>

          <div className={classes.statusItem} style={{ color: signalColor }}>
            <Tooltip title={`Signal: ${isInteger(signal) ? `${signal}%` : 'Unknown'}`}>
              <SignalIcon color='inherit' />
            </Tooltip>
          </div>

          <div className={classes.statusItem} style={{ color: alarmColor }}>
            <Tooltip title={alarm === true ? 'OFFLINE' : 'ONLINE'}>
              <AlarmIcon color='inherit' />
            </Tooltip>
          </div>
        </div>
      </div>
    </div>
  );
}

SiteCard.propTypes = {
  business: PropTypes.object,
  site: PropTypes.object
}

export default SiteCard;
